import { z, ZodType } from 'zod';
import { Setting, settingSchema } from './setting';

export type GameSetting = {
	currency: string;
	account: {
		id: number;
		name: string;
	};
	isResettable: boolean;
	settings: Setting[];
};

export const gameSettingSchema: ZodType<GameSetting> = z.object({
	currency: z.string(),
	account: z.object({
		id: z.number(),
		name: z.string(),
	}),
	isResettable: z.boolean(),
	settings: z.array(settingSchema),
});
